import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import objectHash from 'object-hash';
import React from 'react';
import getVideoId from 'get-video-id';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Cookies, withCookies } from 'react-cookie';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Snackbar from '@mui/material/Snackbar';
import NoSsr from '@mui/material/NoSsr';
import Button from '@mui/material/Button';
import NoteAdd from '@mui/icons-material/NoteAdd';
import AppContext from '../../../context';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { getUserDefaultSubtitlesLangCode, getUserSubtitlePreferences, isIOS } from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../../helpers/checkAuth';
import history from '../../../history';
import Intercom from '../../../widgets/Intercom';
import GoToNextSection from '../GoToNextSection/GoToNextSection';
import VideoNotePopover from '../VideoNotePopover/VideoNotePopover';
import messages from '../lessonDetailsMessages';
import s from './Video.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var Video = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    course: state.courseDetails.course,
    videoNotes: state.lessonDetails.videoNotes,
    totalTranscodingJobs: state.transcodingJobs.total,
    lang: state.intl.locale,
    offline: state.online.offline,
    isPlayerLoaded: state.lessonDetails.isPlayerLoaded,
    isNotesShown: state.lessonDetails.isNotesShown,
    loadingVideoNotes: state.lessonDetails.loadingVideoNotes
  };
}, function (dispatch) {
  return bindActionCreators({
    updateState: lessonDetailsActions.updateState
  }, dispatch);
}), injectIntl(_class = withCookies(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Video, _React$Component);
  var _super = _createSuper(Video);
  function Video() {
    var _this;
    _classCallCheck(this, Video);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      goToNextSectionItemProgress: 0,
      isSnackBarShown: false,
      isAddVideoNoteOpen: false,
      videoNoteTime: 0
    });
    _defineProperty(_assertThisInitialized(_this), "player", null);
    _defineProperty(_assertThisInitialized(_this), "onVideoPlayerUnmount", function () {
      if (_this.player) {
        try {
          // this.player.pause(); // todo take a look a this
          _this.removeVideoPlayerEvents();
          _this.cancelGoToNextSectionItem();
          // this.player.dispose();
        } catch (error) {
          console.error(error);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onVideoClick", function () {
      _this.props.handleChangeVideoFullPage(false, function () {
        if (_.get(_assertThisInitialized(_this), 'player.resizeVideoJS')) {
          _this.player.resizeVideoJS();
        }
      });
      _this.props.cookies.set('contentTypeSwitchers', _this.props.contentTypeSwitchers, {
        path: '/',
        domain: window.App.cookieDomain
      });
      if (!isMobileUserAgent()) {
        Intercom.boot(_this.props.auth.user, _this.context.whitelabeling);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onVideoPlayerSetup", function (player) {
      var _this$props = _this.props,
        formatMessage = _this$props.intl.formatMessage,
        totalTranscodingJobs = _this$props.totalTranscodingJobs,
        lesson = _this$props.lesson;
      if (totalTranscodingJobs && !_.get(lesson, 'videos.length') && !lesson.youtubeVideoUrl) {
        player.$('.vjs-poster').classList.add('vjs-transcoding');
        player.$(
        // eslint-disable-line
        '.vjs-poster').innerHTML = "<div class=\"vjs-transcoding-spinner\"></div><div class=\"vjs-transcoding-content\">".concat(formatMessage(messages.isTranscoding), "</div>");
      } else {
        player.$('.vjs-poster').classList.remove('vjs-transcoding');
        // console.log(player.$('.vjs-loading-spinner'));
        // player.$('.vjs-loading-spinner').hidden = true;
        player.$(
        // eslint-disable-line
        '.vjs-poster').innerHTML = '';
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onVideoPlayerReady", function (player) {
      _this.props.playerRef({
        player: player,
        toggleNotes: _this.toggleNotes
      });
      _this.player = player;
      var _this$props2 = _this.props,
        query = _this$props2.query,
        lesson = _this$props2.lesson,
        videoNotes = _this$props2.videoNotes,
        complete = _this$props2.complete,
        updateState = _this$props2.updateState,
        playFrom = _this$props2.playFrom,
        lang = _this$props2.lang;
      var _ref = lesson.youtubeVideoUrl ? getVideoId(lesson.youtubeVideoUrl) : {},
        service = _ref.service;
      if (service === 'youtube') {
        player.removeChild('LoadingSpinner');
      }
      var videoNoteId = _.get(query, 'videoNoteId');
      var videoNote = videoNoteId && _.find(videoNotes, {
        _id: videoNoteId
      });

      // if (player && player.tech_&& player.tech_.ytPlayer) {
      //   const progressBar = player.el_.querySelector('.vjs-progress-control');
      //   const iframeBlocker = player.el_.querySelector('.vjs-iframe-blocker');
      //   player.el_.addEventListener('click', (event) => {
      //     const playerState = player.tech_.ytPlayer.getPlayerState();
      //
      //     if (event.target !== progressBar && event.target !== player.el_ && event.target !== iframeBlocker) {
      //       return;
      //     }
      //     if (playerState == YT.PlayerState.ENDED) {
      //       player.currentTime(0);
      //       player.play();
      //     } else if (playerState == YT.PlayerState.PAUSED) {
      //       player.play();
      //     } else if (playerState == YT.PlayerState.PLAYING) {
      //       player.pause();
      //     }
      //   });
      // }

      if (_.get(_this.props, 'videoStop')) {
        player.one('play', function () {
          if (_.isFunction(player && player.pause) && !isIOS()) {
            player.pause();
          }
        });
      }
      if (videoNote) {
        player.one('play', function () {
          setTimeout(function () {
            if (_.isFunction(player && player.pause)) {
              player.pause();
              player.currentTime(videoNote.time);
              if (!isIOS()) {
                player.play()["catch"](function (err) {
                  return console.error(err);
                });
              }
            }
          }, 500);
        });
      }
      player.on('timeupdate', function () {
        var percent = player.currentTime() / player.duration() * 100;
        if (percent > 90 && !lesson.isCompleted) {
          Promise.resolve(complete())["catch"](function (error) {
            return console.error(error);
          });
        }
      });
      player.on('ended', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props3, nextPath, nextItem, auth, complete, lesson, isCompleted, timeout, startTs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props3 = _this.props, nextPath = _this$props3.nextPath, nextItem = _this$props3.nextItem, auth = _this$props3.auth, complete = _this$props3.complete, lesson = _this$props3.lesson;
              _this.props.handleChangeVideoFullPage(false);
              _context.prev = 2;
              if (lesson.isCompleted) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return complete();
            case 6:
              isCompleted = _context.sent;
              if (isCompleted) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              return _context.abrupt("return");
            case 15:
              if (_this.props.goToNextLesson) {
                _this.props.goToNextLesson();
              }
              if (!(!nextItem || !nextPath || !isLoggedIn(auth))) {
                _context.next = 18;
                break;
              }
              return _context.abrupt("return");
            case 18:
              timeout = 7000; // todo move it to config
              startTs = Date.now();
              _this.invervalTimer = setInterval(function () {
                var goToNextSectionItemProgress = (Date.now() - startTs) / timeout * 100;
                if (goToNextSectionItemProgress > 100) {
                  clearInterval(_this.invervalTimer);
                  return;
                }
                _this.setState({
                  goToNextSectionItemProgress: goToNextSectionItemProgress
                });
              }, 20);
              _this.timeoutTimer = setTimeout(function () {
                _this.cancelGoToNextSectionItem();
                history.push("/".concat(lang).concat(_this.context.organizationSlug ? "/".concat(_this.context.organizationSlug) : '').concat(nextPath));
              }, timeout);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 11]]);
      })));
      _this.player.on('qualitySelected', function (el, _ref3) {
        var label = _ref3.label;
        _this.props.cookies.set('videoQuality', label, {
          path: '/',
          domain: window.App.cookieDomain
        });
      });
      if (!_this.props.loadingVideoNotes) {
        _this.updateVideoNotes(videoNotes);
      }
      updateState('isPlayerLoaded', true);
      // const { videoFullPage } = this.state;
      if (playFrom) {
        _this.player.currentTime(playFrom);
      }
      var isExternalVideoService = _.includes(['vimeo', 'youtube'], service);
      var textSettings = player.textTrackSettings;
      var subtitlePreferences = getUserSubtitlePreferences(_this.props.auth);
      if (textSettings && subtitlePreferences) {
        textSettings.setValues(subtitlePreferences);
        textSettings.updateDisplay();
      }
      if (textSettings) {
        setTimeout(function () {
          var doneBtn = player.$('.vjs-done-button');
          var resetBtn = player.$('.vjs-default-button');
          if (isLoggedIn(_this.props.auth) && doneBtn) {
            doneBtn.addEventListener('click', function () {
              var currentSettings = textSettings.getValues();
              _this.props.updateSubtitleSettings({
                subtitlePreferences: currentSettings
              });
            });
          }
          if (isLoggedIn(_this.props.auth) && resetBtn) {
            resetBtn.addEventListener('click', function () {
              var defaultSettings = {
                backgroundColor: '#000',
                backgroundOpacity: '1',
                color: '#FFF',
                fontFamily: 'proportionalSansSerif',
                fontPercent: 1.25,
                textOpacity: '1',
                windowColor: '#000',
                windowOpacity: '0'
              };
              _this.props.updateSubtitleSettings({
                subtitlePreferences: defaultSettings
              });
            });
          }
        }, 0);
      }
      var tracks = player.textTracks();
      var lastSavedTrackLang = null;
      var trackChangeTimeout = null;
      var activeTracks = player.textTracks();
      player.on('texttrackchange', function () {
        clearTimeout(trackChangeTimeout);
        trackChangeTimeout = setTimeout(function () {
          var selectedLang = null;
          for (var i = 0; i < activeTracks.length; i += 1) {
            var track = tracks[i];
            if (track.mode === 'showing') {
              selectedLang = track.language;
              break;
            }
          }
          var changed = selectedLang !== lastSavedTrackLang;
          if (isLoggedIn(_this.props.auth) && changed) {
            lastSavedTrackLang = selectedLang;
            _this.props.updateSubtitleSettings({
              defaultSubtitlesCode: lastSavedTrackLang
            }); // null if subtitles turned off
          }
        }, 300);
      });
      if (!isIOS()) {
        player.play().then(function () {
          if (isExternalVideoService) {
            _.invoke(player.$('.vjs-poster'), 'remove');
          }
        })["catch"](function (err) {
          if (isExternalVideoService) {
            _.invoke(player.$('.vjs-poster'), 'remove');
          }
          console.error(err);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "openVideoNotePopover", function () {
      _this.player.pause();
      _this.setState({
        isAddVideoNoteOpen: true,
        videoNoteTime: _this.player.currentTime()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleVideoNotePopoverClose", function () {
      _this.setState({
        isAddVideoNoteOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "cancelGoToNextSectionItem", function () {
      clearTimeout(_this.timeoutTimer);
      clearInterval(_this.invervalTimer);
      _this.setState({
        goToNextSectionItemProgress: 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeVideoPlayerEvents", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        player = _assertThisInitialize.player;
      player.off('timeupdate');
      player.off('ended');
      player.off('play');
      // player.dispose();
    });
    _defineProperty(_assertThisInitialized(_this), "updateVideoNotes", function (videoNotes) {
      if (_.get(_assertThisInitialized(_this), 'player.markers.removeAll')) {
        _this.player.markers.removeAll();
      }
      if (_.isFunction(_.get(_assertThisInitialized(_this), 'player.markers'))) {
        _this.player.markers({
          markerStyle: {
            width: '7px',
            'border-radius': '30%',
            'background-color': 'red'
          },
          markerTip: {
            display: true,
            text: function text(_ref4) {
              var _text = _ref4.text;
              return _text;
            },
            time: function time(_ref5) {
              var _time = _ref5.time;
              return _time;
            }
          },
          breakOverlay: {
            display: true,
            displayTime: 8,
            style: {
              width: '100%',
              height: '40px',
              'background-color': 'rgba(0,0,0,0.7)',
              color: 'white',
              'font-size': '17px'
            },
            text: function text(_ref6) {
              var _text2 = _ref6.text;
              return _text2;
            }
          },
          onMarkerClick: function onMarkerClick() {},
          onMarkerReached: function onMarkerReached() {},
          markers: _.map(videoNotes, function (_ref7) {
            var time = _ref7.time,
              text = _ref7.text;
            return {
              overlayText: text,
              text: text,
              time: time
            };
          })
        });
      }
      if (_.get(_assertThisInitialized(_this), 'player.markers.add')) {
        _this.player.markers.add(_.map(videoNotes, function (_ref8) {
          var time = _ref8.time,
            text = _ref8.text;
          return {
            overlayText: text,
            text: text,
            time: time
          };
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleNotes", function (isNotesShown) {
      var videoNotes = _this.props.videoNotes;
      if (_this.player && _.get(_assertThisInitialized(_this), 'player.markers.removeAll')) {
        _this.player.markers.removeAll();
        if (isNotesShown) {
          _this.player.markers.add(_.map(videoNotes, function (_ref9) {
            var time = _ref9.time,
              text = _ref9.text;
            return {
              overlayText: text,
              text: text,
              time: time
            };
          }));
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideSnackBar", function () {
      _this.setState({
        isSnackBarShown: false
      });
    });
    return _this;
  }
  _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      setTimeout(function () {
        if (!_.has(_this2.props.query, 'showEvaluationModal')) {
          _this2.setState({
            isSnackBarShown: _this2.props.videoFullPage
          });
        }
      }, 1000);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (objectHash(_.get(this, 'props.videoNotes', [])) !== objectHash(_.get(nextProps, 'videoNotes', []))) {
        this.updateVideoNotes(nextProps.videoNotes);
      }
      if (this.props.isLessonReviewFocused !== nextProps.isLessonReviewFocused && nextProps.isLessonReviewFocused) {
        if (this.player && !this.player.ended()) {
          this.player.pause();
        } else {
          this.cancelGoToNextSectionItem();
        }
      }
      if (this.props.videoStop !== nextProps.videoStop && !nextProps.videoStop && !isIOS() && this.player && !this.player.ended()) {
        this.player.play()["catch"](function (err) {
          return console.error(err);
        });
        this.setState({
          isSnackBarShown: this.props.videoFullPage
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        lesson = _this$props4.lesson,
        videoFullPage = _this$props4.videoFullPage,
        cookies = _this$props4.cookies,
        nextUrl = _this$props4.nextUrl,
        nextPath = _this$props4.nextPath,
        nextItem = _this$props4.nextItem,
        contentTypeSwitchers = _this$props4.contentTypeSwitchers,
        lang = _this$props4.lang,
        formatMessage = _this$props4.intl.formatMessage,
        className = _this$props4.className,
        offline = _this$props4.offline,
        course = _this$props4.course,
        isNotesShown = _this$props4.isNotesShown,
        isPlayerLoaded = _this$props4.isPlayerLoaded,
        auth = _this$props4.auth,
        totalTranscodingJobs = _this$props4.totalTranscodingJobs,
        thumbnailVimeoImg = _this$props4.thumbnailVimeoImg;
      var _this$state = this.state,
        goToNextSectionItemProgress = _this$state.goToNextSectionItemProgress,
        isSnackBarShown = _this$state.isSnackBarShown,
        videoNoteTime = _this$state.videoNoteTime,
        isAddVideoNoteOpen = _this$state.isAddVideoNoteOpen;
      var _this$context = this.context,
        whitelabeling = _this$context.whitelabeling,
        organizationSlug = _this$context.organizationSlug;
      var getVideoLoaderUrl = function getVideoLoaderUrl(whitelabeledOptions, pathTo, defaultLoader) {
        var path = _.get(whitelabeledOptions, "".concat(pathTo)) ? "".concat(_this3.context.cloudfrontUrl).concat(_.get(whitelabeling, "".concat(pathTo))) : defaultLoader;
        return path;
      };
      var videoLoader = organizationSlug && !lesson.isSharedToWhitelabeledOrg ? getVideoLoaderUrl(whitelabeling, 'videoLoader', "".concat(this.context.cloudfrontUrl, "/video-loader.png")) : "".concat(this.context.cloudfrontUrl, "/video-loader.png");
      var thumbnail = [{
        srcset: videoLoader,
        type: 'image/png'
      }];
      var selected = cookies.get('videoQuality') || _.get(_.maxBy(lesson.videos, function (_ref10) {
        var label = _ref10.label;
        return parseInt(label, 10);
      }), 'label', '1080p');
      var sources = _.map(_.sortBy(lesson.videos, function (_ref11) {
        var label = _ref11.label;
        return -parseInt(label, 10);
      }), function (_ref12) {
        var label = _ref12.label,
          _ref12$file = _ref12.file,
          path = _ref12$file.path,
          mimetype = _ref12$file.mimetype;
        return {
          key: path,
          src: "".concat(_this3.context.cloudfrontUrl, "/").concat(path),
          type: mimetype,
          label: label,
          selected: selected === label
        };
      });
      var tracks = _.map(lesson.subtitles, function (item) {
        var _item$subtitlesLangua, _item$subtitlesLangua2, _item$subtitlesLangua3, _item$subtitlesLangua4, _item$subtitlesLangua5;
        return {
          key: item.file.path,
          src: "".concat(_this3.context.cloudfrontUrl, "/").concat(item.file.path),
          srclang: ((_item$subtitlesLangua = item.subtitlesLanguageId) === null || _item$subtitlesLangua === void 0 ? void 0 : _item$subtitlesLangua.code) || item.customLangCode,
          label: (_item$subtitlesLangua2 = item.subtitlesLanguageId) !== null && _item$subtitlesLangua2 !== void 0 && _item$subtitlesLangua2.isTranslatedOnUI ? formatMessage(messages["".concat(item.subtitlesLanguageId.code, "SubtitlesLabel")]) : ((_item$subtitlesLangua3 = item.subtitlesLanguageId) === null || _item$subtitlesLangua3 === void 0 ? void 0 : _item$subtitlesLangua3.name) || item.customLangName,
          "default": getUserDefaultSubtitlesLangCode(auth) && [(_item$subtitlesLangua4 = item.subtitlesLanguageId) === null || _item$subtitlesLangua4 === void 0 ? void 0 : _item$subtitlesLangua4.code, item.customLangCode].includes(getUserDefaultSubtitlesLangCode(auth)) ? ((_item$subtitlesLangua5 = item.subtitlesLanguageId) === null || _item$subtitlesLangua5 === void 0 ? void 0 : _item$subtitlesLangua5.code) || item.customLangCode : null,
          kind: 'captions'
        };
      });
      var videoJsOptions = {
        autoplay: !isIOS(),
        controls: true,
        speed: true,
        playbackRates: [0.85, 1, 1.3, 1.5, 1.75],
        sources: sources,
        tracks: tracks,
        poster: thumbnailVimeoImg || thumbnail[0].srcset,
        thumbnail: thumbnail,
        // responsive: true,
        // fluid: true,
        language: lang,
        playsInline: isIOS(),
        html5: {
          nativeTextTracks: false // 👈 this forces Video.js to use its custom captions UI
        },

        controlBar: {
          children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'progressControl', 'playbackRateMenuButton', 'qualitySelector', 'fullscreenToggle', 'subsCapsButton']
        }
      };
      var _ref13 = lesson.youtubeVideoUrl ? getVideoId(lesson.youtubeVideoUrl) : {},
        service = _ref13.service;
      if (service === 'youtube') {
        videoJsOptions.sources = [{
          type: 'video/youtube',
          src: lesson.youtubeVideoUrl
        }];
        videoJsOptions.youtube = {
          hl: lang,
          ytControls: 2,
          playsinline: !isIOS(),
          start: 1
        };
        videoJsOptions.controls = false;
        if (isIOS()) {
          videoJsOptions.poster = null;
          videoJsOptions.thumbnail = null;
        }
      }
      if (service === 'vimeo') {
        videoJsOptions.sources = [{
          type: 'video/vimeo',
          src: lesson.youtubeVideoUrl
        }];
        videoJsOptions.vimeo = {
          playsinline: !isIOS()
        };
      }
      if (!videoJsOptions.sources.length) {
        videoJsOptions.techOrder = ['html5'];
      }
      var videoNoteIsNotAvailable = isLoggedIn(auth) && course._id;
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "sAvMyLJYnrhGY0ucOaxov",
        className: classNames(s.lessonVideoContent, !contentTypeSwitchers.text && s.fullWidth, videoFullPage && s.fullPage, videoFullPage && 'full-page-video-wrapper', className
        // !videoNoteIsNotAvailable ? s.videoNoteIsHidden : undefined,
        ),

        onClick: videoFullPage ? function (e) {
          return _this3.onVideoClick(e);
        } : null,
        onKeyPress: videoFullPage ? function (e) {
          return _this3.onVideoClick(e);
        } : null,
        role: "button",
        tabIndex: "-1"
      }, void 0, /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/React.createElement(VideoPlayer, _extends({
        onReady: this.onVideoPlayerReady,
        onSetup: this.onVideoPlayerSetup,
        onUnmount: this.onVideoPlayerUnmount,
        key: lesson._id,
        goToNextSection: !!goToNextSectionItemProgress && nextItem && /*#__PURE__*/_jsx(GoToNextSection, {
          nextItem: nextItem,
          nextUrl: nextUrl,
          nextPath: nextPath,
          goToNextSectionItemProgress: goToNextSectionItemProgress,
          cancelGoToNextSectionItem: this.cancelGoToNextSectionItem
        })
      }, videoJsOptions))), videoNoteIsNotAvailable && service !== 'vimeo' && service !== 'youtube' && /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx("div", {
        className: s.addNoteWrapper
      }, void 0, /*#__PURE__*/React.createElement(Button, {
        "data-test-id": "haKuATGqKh5-edRPGhpt6",
        color: "primary",
        size: "large",
        className: classNames(s.addNote),
        onClick: this.openVideoNotePopover,
        ref: function ref(node) {
          _this3.videoNoteAnchorEl = node;
        },
        disabled: !isPlayerLoaded || !isNotesShown || totalTranscodingJobs && !_.get(lesson, 'videos.length') && !lesson.youtubeVideoUrl,
        id: "add-video-note-btn"
      }, /*#__PURE__*/_jsx(NoteAdd, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.addNoteLabel)))), /*#__PURE__*/_jsx(Snackbar, {
        open: isSnackBarShown,
        onClose: this.hideSnackBar,
        autoHideDuration: 5000,
        message: formatMessage(messages.clickOnVideoToExitFullScreen),
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      }), isLoggedIn(auth) && isAddVideoNoteOpen && course._id && !offline && /*#__PURE__*/_jsx(VideoNotePopover, {
        handleVideoNotePopoverClose: this.handleVideoNotePopoverClose,
        videoNoteTime: videoNoteTime,
        videoNoteAnchorEl: this.videoNoteAnchorEl,
        isAddVideoNoteOpen: isAddVideoNoteOpen
      }));
    }
  }]);
  return Video;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  query: {},
  playerRef: function playerRef() {
    return null;
  },
  playFrom: undefined,
  nextItem: undefined,
  nextUrl: undefined,
  nextPath: undefined,
  auth: {},
  className: '',
  isLessonReviewFocused: false,
  videoStop: false,
  thumbnailVimeoImg: '',
  goToNextLesson: _.noop
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Video, _extends({}, props, {
    playerRef: ref
  }));
});